import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "20",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.143 13.244 15.98 11l2.698 5.641L13 19.143l.805-2.23S5.75 13.375 6.097 6c2.715 5.938 9.046 7.244 9.046 7.244M24 6v18H6v-6H0V0h18v6zm-2 2H9.888a10.3 10.3 0 0 1-1.521-2H16V2H2v14h4v-3.124c.6.961 1.287 1.823 2 2.576V22h14z"
    }, null, -1)
  ]))]))
}
export default { render: render }